import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";

export const MotifDialog = ({ etape, onValider, onFermer }) => {
  const [motif, setMotif] = useState("");
  return (
    <Dialog open={Boolean(etape)} onOpenChange={(o) => !o && onFermer()}>
      <DialogContent className="at-popover max-w-[calc(100vw-24px)] sm:max-w-md" data-testid="lost-reason-dialog">
        <DialogHeader>
          <DialogTitle>Passer en « {etape?.nom} »</DialogTitle>
          <DialogDescription className="at-muted">Le motif est obligatoire.</DialogDescription>
        </DialogHeader>
        <form onSubmit={(e) => { e.preventDefault(); onValider(etape.code, motif); setMotif(""); }} className="space-y-3">
          <textarea required value={motif} onChange={(e) => setMotif(e.target.value)} rows={3} placeholder="Ex. a déjà signé avec un concurrent"
            className="at-input py-3" data-testid="lost-reason-input" />
          <button type="submit" disabled={!motif.trim()} className="at-btn at-btn-primary w-full" data-testid="lost-reason-submit">Valider</button>
        </form>
      </DialogContent>
    </Dialog>
  );
};
